app.mediator.registerModule(MODULE_NAME__SOCIAL_MEDIA_SHARE_POPUP, function (app) {

    // "Private class" variables
    var modal;
    var helpers;

    return {

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            modal = app.ui.uiPlugins.modal;
            helpers = app.helpers.funcs;
            this.addMediatorListeners();
            modal.getMainModalElem().on('hidden.bs.modal', function () {
                app.mediator.notify(EVENT_NAME__SOCIAL_MEDIA_SHARE_POPUP__CLOSED);
            });
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {

            var scope = this;

            app.mediator.addListener(EVENT_NAME__PROJECT_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED, function () {
                scope.showModal();
            }, this);

            app.mediator.addListener(EVENT_NAME__NEWS_ARTICLE_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED, function () {
                scope.showModal();
            }, this);

            app.mediator.addListener(EVENT_NAME__HOME_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED, function () {
                scope.showModal();
            }, this);

        },
		
        //==========================================================xdiv2====
        // Module
        //===================================================================

        closeButtonText: 'Close',

        dynamicallySetLinks: function () {
            var $rootElem = modal.getMainModalElem();
            var $links = $rootElem.find('a');
            $links.each(function (linkKey, link) {
                var $link = $(link);
                var href = $link.data('href-template');
                $link.attr('href', href);
            });
        },

        setCloseButtonText: function (text) {
            this.closeButtonText = text;
        },

        showModal: function ($cardElem) {
            var htmlFragment = this.getBodyHtml().querySelectorAll('.template-inner');
            var html = $('<div>').append($(htmlFragment).clone()).html();
            var popupTitle = $(html).find('.popup-title').text();
            modal.addModalClass('social-media-share-modal');
            modal.setSize('md');
            modal.setCloseButtonText(this.closeButtonText);
            modal.clearTitles();
            modal.setScreenReaderTitle(popupTitle);
            modal.setBodyHtml(html);
            this.dynamicallySetLinks();
            modal.show();
        },

        hideModal: function () {
            modal.hide();
        },

        getBodyHtml: function () {
            var $elem = $('#social-media-share-popup-template');
            return helpers.getTemplateHtml($elem.get(0));
        }

	};
});
